import React, { Component } from "react";
import { connect } from 'react-redux';
import { fromJS } from 'immutable';
import { bindActionCreators } from 'redux'

import Form from './Form'
import ActionGet from '../../store/action/BacklogClient/Fetch'
import ActionView from '../../store/action/BacklogClient/View'
import ActionDelete from '../../store/action/BacklogClient/Delete'
import "../../source/util.css"
import { IsEdit, IsCreate, IsView } from '../../store/constants'
import { toast } from "react-toastify";
import ComboboxInput from "../../infra/components/formInput/ComboboxInput";
import CustomGrid from "../../infra/components/grid/custom-grid-without-search";
import ActionGetAllClient from "../../store/action/Client/FetchAll";
import ActionGetAllDivision from "../../store/action/Division/FetchAll";
import ActionGetAllSender from "../../store/action/Sender/FetchAll";
import {ClientId, SenderId} from "../../helper/HelperAuth";
import ActionGetAccessModuleIdAction from '../../store/action/AccessModule/FetchActionDispatch'
import TextInputField from '../../infra/components/formInput/CustomTextInput'
import Swal from "sweetalert2";

class Page extends Component{
    constructor(props){
        super(props)
        this.state = {
            title: "Helpdesk-CS",
            form: fromJS({
                show : false,
                actionType: '',
                item: fromJS({})
            }),
            formSearch: fromJS({
                "search": ""
            }),

            searchForm : fromJS({
                "client-id"     : '',
                "phone-number"  : '',
                "sender-id"     : ''
            }),

            search: fromJS([
                { widthClass:'col-sm-6', id: 'search', placeholder: 'Search', label : '', value:'' },
            ]),
            columns:[
                { className : "col-sm-1", cfield: "counter", caption: "No" },
                { className : "", field: "client_name", caption: "Client", allowSearch: true },
                { className : "", field: "client_id", caption: "Sender", allowSearch: true },
                { className : "", field: "webhook", caption: "Webhook DR", allowSearch: true },
                { className : "", field: "message_webhook", caption: "Webhook Interaktif", allowSearch: true },
                { className : "", field: "phone_number_id", caption: "Phone Number ID", allowSearch: true },
                { className : "col-sm-1", cfield: "action", caption: "Actions" }
            ],
            form_template: fromJS([
                {value : 1 , label : "Group Template"},

            ]),
            errors: fromJS({}),
            actionId:''
        };

        this.showContent = this.showContent.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleNew = this.handleNew.bind(this);
        this.handleFind = this.handleFind.bind(this);
        this.handleViewClicked = this.handleViewClicked.bind(this);
        this.handleEditClicked = this.handleEditClicked.bind(this);
        this.handleRemoveClicked = this.handleRemoveClicked.bind(this);
        this.handleCancelForm = this.handleCancelForm.bind(this);
        this.handlePageChanged = this.handlePageChanged.bind(this);
        // this.changeAction();
    }

    componentDidMount(){
        
        this.props.actionGetAllClient()
        this.props.actionGetAccessModuleIdAction('Register Template');
        this.handleFindSearch(1);
    }


    handleSearch(obj){
        this.setState({ formSearch: obj });
        this.refreshGrid(1, obj);
    }

    handleCancelForm(refresh){
        if(refresh){
            this.handleFindSearch(1);
        }
        this.setState({
            form:  fromJS({
                show: false,
                actionType: '',
                item: fromJS({})
            })
        })
    }

    handleOnBindCustomAction(actionId, row){
        if(actionId=='HoverTemplate'){
            return true;

        }

        return false;
    }

    handleNew(){
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsCreate,
                item: fromJS({})
            })
        })
    }

    handleViewClicked = (value) => {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsView,
                item: value
            })
        })
    }

    handleEditClicked = (value) => {
        this.setState({
            form:  fromJS({
                show: true,
                actionType: IsEdit,
                item: value
            })
        })
    }

    handlePageChanged = (value) => {
        const { formSearch } = this.state;
        this.refreshGrid(value, formSearch);
    }

    refreshGrid(page, search){
        this.handleFindSearch(page);
    }

    static getDerivedStateFromProps(props, state) {
        return null;
    }

    async handleRemoveClicked(value){
        var temp = await this.props.actionDelete(value.get('client_id'));
        if(temp.ok){
            console.log('masuk ok');
            Swal.fire("Deleted!", "Data has been deleted.", "success");
            toast.success('Delete '+ value.get('client_id') +' Success!', toast.POSITION.TOP_RIGHT);
            this.refreshGrid(1, this.state.formSearch);
        }else{
            console.log('masuk nok');
            Swal.fire("Failed!", "Failed to delete data.", "error");
            toast.error('Delete '+ value.get('client_id') +' Failed!', toast.POSITION.TOP_RIGHT);
        }
    }

    handleChange(field, value, label) {

        if (field === 'client-id') {
            this.setState({ client_id: value })
            if (value == null) value = -1;
            this.props.actionGetAllSender(value);
        }

        var formVal = this.state.searchForm;
        formVal = formVal.set(field,value);

        this.setState({ searchForm:formVal })
    }

    handleFind(){
        this.handleFindSearch(1);
    }

    handleFindSearch(page){
        // this.changeAction();
        const {searchForm} = this.state;
        let client_id = searchForm.get('client-id');
        let phone_number=searchForm.get('phone-number');
        var clientData = this.props.clientall.find((item) => item.get('client-id') === searchForm.get('client-id'));
        var senderData = this.props.senderall.find((item) => item.get('sender-id') === searchForm.get('sender-id'));
        let clientName = "";
        let senderName = "";
        if(client_id == null || client_id == undefined 
            ||  client_id == [""]){
            client_id = ClientId
            clientName = "";
        }else {
            clientName = clientData.get('client-name')
        }
        if(senderData == null || senderData == undefined){
            senderName = "";
        } else {
            senderName = senderData.get('sender-name');
        }
        
        this.props.actionGet(page,this.state.sortForm, clientName,senderName,phone_number);
    }

    showContent(){
        var form = this.state.form;

        if(form.get('show') && form.get('actionType') === IsCreate){
            return(
                <Form
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }
                >
                </Form>
            )
        } else if (form.get('show') && form.get('actionType') === IsEdit) {
            return(
                <Form
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }>
                </Form>
            )
        } else if (form.get('show') && form.get('actionType') === IsView) {
            return(
                <Form
                    actionType={ form.get('actionType') }
                    item={ form.get('item') }
                    handleCancelForm={ this.handleCancelForm }
                    handleSubmitOnForm={ this.handleSubmitOnForm }>
                </Form>
            )
        } else {
            const items = this.props.backlogClientData ? fromJS(this.props.backlogClientData) : fromJS({});
            // console.log('items', items);
            const {searchForm, errors} = this.state
            return (
                <div className="clearfix">
                    <div className="card-noborder-mid">
                        <h4>
                            Backlog Client Management
                        </h4>
                    </div>
                    <div className=  'card'>
                        <div className="body">
                            <div className="row">
                                <div className="col-sm-6">
                                    <ComboboxInput
                                        field='client-id'
                                        value={searchForm.get('client-id')}
                                        options={fromJS({
                                            'source': this.props.clientall,
                                            'value': 'client-id',
                                            'label': 'client-name'
                                        }) }
                                        onChange={(field, value, label) => this.handleChange(field,value,label)}
                                        placeholder="Client"
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <TextInputField
                                        className="form-control-text"
                                        field={'phone-number'}
                                        value={searchForm.get('phone-number')}
                                        onChange={(field, value) => this.handleChange(field, value)}
                                        placeholder="Phone Number ID"
                                        hasError={errors.has('phone-number')}
                                    />
                                </div>
                                <div className="col-sm-6">
                                    <ComboboxInput
                                        field='sender-id'
                                        value={searchForm.get('sender-id')}
                                        options={fromJS({
                                        'source': this.props.senderall,
                                        'value': 'sender-id',
                                        'label': 'sender-name'
                                        })}
                                        onChange={(field, value, label) => this.handleChange(field, value, label)}
                                        placeholder="Sender"
                                        disabled={this.state.disabledHead}
                                        // hasError={errors.has('sender-id')}
                                    />
                                </div>
                            </div>
                            <div className="row no-margin-bottom" >
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success"
                                            onClick={this.handleFind}>
                                        Search
                                    </button>
                                </div>
                                <div className="col-sm-1"></div>
                                <div className="col-sm-2">
                                    <button type="button"
                                            className="btn btn-wide btn-success content-add"
                                            onClick={this.handleNew}>
                                        <i className="material-icons">{'add'}</i>{'Add'}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <CustomGrid
                        title="Privilege"
                        columns={ this.state.columns  }
                        items={ items }
                        search={ this.state.search }
                        handleSearch={ this.handleSearch }
                        handleViewClicked={this.handleViewClicked}
                        handleEditClicked={this.handleEditClicked}
                        handleRemoveClicked={this.handleRemoveClicked}
                        handleOnBindCustomAction={ this.handleOnBindCustomAction }
                        handlePageChanged={this.handlePageChanged}
                    >
                    </CustomGrid>
                </div>

            )
        }
    }

    render(){
        const { form } = this.state;
        var title = form.get('show');
        if (form.get('actionType') === IsCreate) {
            title = "Add Backlog Client";
        } else if (form.get('actionType') === IsEdit) {
            title = "Edit Backlog Client";
        } else if (form.get('actionType') === IsView) {
            title = "View Backlog Client";
        }
        return (
            <div className="clearfix">
                <div className="card-noborder">
                    <h4>
                        {title}
                    </h4>
                </div>
                {
                    this.showContent()
                }
            </div>
        );
    }
}


export default connect(
    (state) => {
        return {
            template: state.user.template,
            clientall: state.user.clientall,
            senderall: state.user.senders,
            backlogClientData: state.user.backlogClientData,
            accessmoduleaction: state.user.accessmoduleaction,
        }
    },
    dispatch => bindActionCreators({
        actionGet: ActionGet,
        actionView: ActionView,
        actionDelete: ActionDelete,
        actionGetAllClient:ActionGetAllClient,
        actionGetAllDivision: ActionGetAllDivision,
        actionGetAllSender: ActionGetAllSender,
        actionGetAccessModuleIdAction:ActionGetAccessModuleIdAction,
    }, dispatch),
)(Page);